<script>
import { mapGetters } from 'vuex';
import AutomationActionTeamMessageInput from './AutomationActionTeamMessageInput.vue';
import AutomationActionFileInput from './AutomationFileInput.vue';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import SingleSelect from 'dashboard/components-next/filter/inputs/SingleSelect.vue';
import MultiSelect from 'dashboard/components-next/filter/inputs/MultiSelect.vue';
import NextInput from 'dashboard/components-next/input/Input.vue';

export default {
  components: {
    AutomationActionTeamMessageInput,
    AutomationActionFileInput,
    WootMessageEditor,
    NextButton,
    SingleSelect,
    MultiSelect,
    NextInput,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => null,
    },
    actionTypes: {
      type: Array,
      default: () => [],
    },
    dropdownValues: {
      type: Array,
      default: () => [],
    },
    errorMessage: {
      type: String,
      default: '',
    },
    showActionInput: {
      type: Boolean,
      default: true,
    },
    initialFileName: {
      type: String,
      default: '',
    },
    isMacro: {
      type: Boolean,
      default: false,
    },
    dropdownMaxHeight: {
      type: String,
      default: 'max-h-80',
    },
  },
  emits: ['update:modelValue', 'input', 'removeAction', 'resetAction'],
  data() {
    return {
            standardContactAttributes: [
        { id: 'is_client', name: 'É Cliente (Sim/Não)' },
        { id: 'signed_contract', name: 'Contrato Assinado (Sim/Não)' },
        { id: 'name', name: 'Nome' },
        { id: 'email', name: 'E-mail' },
        { id: 'phone_number', name: 'Telefone' },
        { id: 'company_name', name: 'Empresa' },
        { id: 'city', name: 'Cidade' },
        { id: 'cpf', name: 'CPF' },
        { id: 'physical_folder', name: 'Número de pasta' },
        { id: 'inss_password', name: 'Senha INSS' },
      ],
      booleanOptions: [
        { id: true, name: 'Sim (Verdadeiro)' },
        { id: false, name: 'Não (Falso)' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      customAttributes: 'attributes/getAttributes',
    }),
    contactCustomAttributes() {
      return (this.customAttributes || []).filter(
        attr => attr.attribute_model === 'contact_attribute'
      );
    },
    conversationCustomAttributes() {
      return (this.customAttributes || []).filter(
        attr => attr.attribute_model === 'conversation_attribute'
      );
    },
    contactCustomAttributesAsOptions() {
      return this.contactCustomAttributes.map(attr => ({
        id: attr.attribute_key,
        name: attr.attribute_display_name,
      }));
    },
    convCustomAttributesAsOptions() {
      return this.conversationCustomAttributes.map(attr => ({
        id: attr.attribute_key,
        name: attr.attribute_display_name,
      }));
    },
    action_name: {
      get() {
        if (!this.modelValue) return null;
        return this.modelValue.action_name;
      },
      set(value) {
        const payload = this.modelValue || {};
        this.$emit('update:modelValue', { ...payload, action_name: value });
        this.$emit('input', { ...payload, action_name: value });
      },
    },
    action_params: {
      get() {
        if (!this.modelValue) return null;
        return this.modelValue.action_params;
      },
      set(value) {
        const payload = this.modelValue || {};
        this.$emit('update:modelValue', { ...payload, action_params: value });
        this.$emit('input', { ...payload, action_params: value });
      },
    },
    inputType() {
      return this.actionTypes.find(action => action.key === this.action_name)
        ?.inputType;
    },
    actionNameAsSelectModel: {
      get() {
        if (!this.action_name) return null;
        const found = this.actionTypes.find(a => a.key === this.action_name);
        return found ? { id: found.key, name: found.label } : null;
      },
      set(value) {
        this.action_name = value?.id || value;
      },
    },
    actionTypesAsOptions() {
      return this.actionTypes.map(a => ({ id: a.key, name: a.label }));
    },
    isVerticalLayout() {
      return ['team_message', 'textarea'].includes(this.inputType);
    },
    castMessageVmodel: {
      get() {
        if (Array.isArray(this.action_params)) {
          return this.action_params[0];
        }
        return this.action_params;
      },
      set(value) {
        this.action_params = value;
      },
    },

    // WAIT ACTION
    waitModel: {
      get() {
        if (Array.isArray(this.action_params) && this.action_params[0] !== undefined) {
          return this.action_params[0];
        }
        return '';
      },
      set(val) {
        this.action_params = val === '' ? [] : [Number(val)];
      },
    },

        // CONTACT STANDARD ATTRIBUTE ACTION
    isBooleanContactAttr() {
      return ['is_client', 'signed_contract'].includes(this.contactAttrParam.attribute_key);
    },
    contactAttrParam() {
      if (Array.isArray(this.action_params) && this.action_params[0] && typeof this.action_params[0] === 'object') {
        return this.action_params[0];
      }
      return { attribute_key: '', attribute_value: '' };
    },
    contactAttrKeyModel: {
      get() {
        const key = this.contactAttrParam.attribute_key;
        const found = this.standardContactAttributes.find(a => a.id === key);
        return found || (key ? { id: key, name: key } : null);
      },
      set(val) {
        const key = val?.id !== undefined ? val.id : val;
        this.action_params = [{
          attribute_key: key,
          attribute_value: ['is_client', 'signed_contract'].includes(key) ? true : (this.contactAttrParam.attribute_value || ''),
        }];
      },
    },
    contactAttrValModel: {
      get() {
        return this.contactAttrParam.attribute_value ?? '';
      },
      set(val) {
        this.action_params = [{
          attribute_key: this.contactAttrParam.attribute_key || '',
          attribute_value: val,
        }];
      },
    },
    contactAttrValModelBoolean: {
      get() {
        const val = this.contactAttrParam.attribute_value;
        if (val === null || val === undefined || val === '') return null;
        const boolVal = val === true || val === 'true';
        return this.booleanOptions.find(opt => opt.id === boolVal) || null;
      },
      set(val) {
        const v = val?.id !== undefined ? val.id : val;
        this.contactAttrValModel = v;
      },
    },

    // CONTACT CUSTOM ATTRIBUTE ACTION
    contactCustomAttrParam() {
      if (Array.isArray(this.action_params) && this.action_params[0] && typeof this.action_params[0] === 'object') {
        return this.action_params[0];
      }
      return { attribute_key: '', attribute_value: '' };
    },
    selectedContactCustomAttrDef() {
      return this.contactCustomAttributes.find(
        attr => attr.attribute_key === this.contactCustomAttrParam.attribute_key
      );
    },
    selectedContactCustomAttrType() {
      return this.selectedContactCustomAttrDef?.attribute_display_type || 'text';
    },
    selectedContactCustomAttrListOptions() {
      const values = this.selectedContactCustomAttrDef?.attribute_values || [];
      return values.map(v => ({ id: v, name: v }));
    },
    contactCustomAttrKeyModel: {
      get() {
        const key = this.contactCustomAttrParam.attribute_key;
        const found = this.contactCustomAttributesAsOptions.find(a => a.id === key);
        return found || (key ? { id: key, name: key } : null);
      },
      set(val) {
        const key = val?.id !== undefined ? val.id : val;
        this.action_params = [{ attribute_key: key, attribute_value: '' }];
      },
    },
    contactCustomAttrValModel: {
      get() {
        return this.contactCustomAttrParam.attribute_value ?? '';
      },
      set(val) {
        this.action_params = [{
          attribute_key: this.contactCustomAttrParam.attribute_key || '',
          attribute_value: val,
        }];
      },
    },
    contactCustomAttrValModelSelect: {
      get() {
        const val = this.contactCustomAttrParam.attribute_value;
        if (val === null || val === undefined || val === '') return null;
        return { id: val, name: val };
      },
      set(val) {
        const v = val?.id !== undefined ? val.id : val;
        this.contactCustomAttrValModel = v;
      },
    },
    contactCustomAttrValModelBoolean: {
      get() {
        const val = this.contactCustomAttrParam.attribute_value;
        if (val === null || val === undefined || val === '') return null;
        return this.booleanOptions.find(opt => opt.id === val) || null;
      },
      set(val) {
        const v = val?.id !== undefined ? val.id : val;
        this.contactCustomAttrValModel = v;
      },
    },

    // CONVERSATION CUSTOM ATTRIBUTE ACTION
    convCustomAttrParam() {
      if (Array.isArray(this.action_params) && this.action_params[0] && typeof this.action_params[0] === 'object') {
        return this.action_params[0];
      }
      return { attribute_key: '', attribute_value: '' };
    },
    selectedConvCustomAttrDef() {
      return this.conversationCustomAttributes.find(
        attr => attr.attribute_key === this.convCustomAttrParam.attribute_key
      );
    },
    selectedConvCustomAttrType() {
      return this.selectedConvCustomAttrDef?.attribute_display_type || 'text';
    },
    selectedConvCustomAttrListOptions() {
      const values = this.selectedConvCustomAttrDef?.attribute_values || [];
      return values.map(v => ({ id: v, name: v }));
    },
    convCustomAttrKeyModel: {
      get() {
        const key = this.convCustomAttrParam.attribute_key;
        const found = this.convCustomAttributesAsOptions.find(a => a.id === key);
        return found || (key ? { id: key, name: key } : null);
      },
      set(val) {
        const key = val?.id !== undefined ? val.id : val;
        this.action_params = [{ attribute_key: key, attribute_value: '' }];
      },
    },
    convCustomAttrValModel: {
      get() {
        return this.convCustomAttrParam.attribute_value ?? '';
      },
      set(val) {
        this.action_params = [{
          attribute_key: this.convCustomAttrParam.attribute_key || '',
          attribute_value: val,
        }];
      },
    },
    convCustomAttrValModelSelect: {
      get() {
        const val = this.convCustomAttrParam.attribute_value;
        if (val === null || val === undefined || val === '') return null;
        return { id: val, name: val };
      },
      set(val) {
        const v = val?.id !== undefined ? val.id : val;
        this.convCustomAttrValModel = v;
      },
    },
    convCustomAttrValModelBoolean: {
      get() {
        const val = this.convCustomAttrParam.attribute_value;
        if (val === null || val === undefined || val === '') return null;
        return this.booleanOptions.find(opt => opt.id === val) || null;
      },
      set(val) {
        const v = val?.id !== undefined ? val.id : val;
        this.convCustomAttrValModel = v;
      },
    },
  },
  methods: {
    removeAction() {
      this.$emit('removeAction');
    },
    resetAction() {
      this.$emit('resetAction');
    },
    onActionNameChange(value) {
      this.actionNameAsSelectModel = value;
      this.resetAction();
    },
  },
};
</script>

<template>
  <li class="list-none py-2 first:pt-0 last:pb-0">
    <div
      class="flex flex-col gap-2"
      :class="{ 'animate-wiggle': errorMessage }"
    >
      <div class="flex items-center gap-2 flex-wrap sm:flex-nowrap">
        <SingleSelect
          :model-value="actionNameAsSelectModel"
          :options="actionTypesAsOptions"
          :dropdown-max-height="dropdownMaxHeight"
          disable-deselect
          class="flex-shrink-0"
          @update:model-value="onActionNameChange"
        />
        <template v-if="showActionInput && !isVerticalLayout">
          <SingleSelect
            v-if="inputType === 'search_select'"
            v-model="action_params"
            :options="dropdownValues"
            :dropdown-max-height="dropdownMaxHeight"
          />
          <MultiSelect
            v-else-if="inputType === 'multi_select'"
            v-model="action_params"
            :options="dropdownValues"
            :dropdown-max-height="dropdownMaxHeight"
          />
          <NextInput
            v-else-if="inputType === 'email'"
            v-model="action_params"
            type="email"
            size="sm"
            :placeholder="$t('AUTOMATION.ACTION.EMAIL_INPUT_PLACEHOLDER')"
          />
          <NextInput
            v-else-if="inputType === 'url'"
            v-model="action_params"
            type="url"
            size="sm"
            :placeholder="$t('AUTOMATION.ACTION.URL_INPUT_PLACEHOLDER')"
          />
          <AutomationActionFileInput
            v-else-if="inputType === 'attachment'"
            v-model="action_params"
            :initial-file-name="initialFileName"
          />
          <NextInput
            v-else-if="inputType === 'wait'"
            v-model="waitModel"
            type="number"
            min="1"
            max="60"
            size="sm"
            placeholder="Segundos de espera (ex: 5, 10, 30)"
          />
                    <template v-else-if="inputType === 'contact_attribute'">
            <SingleSelect
              v-model="contactAttrKeyModel"
              :options="standardContactAttributes"
              :dropdown-max-height="dropdownMaxHeight"
              disable-deselect
              placeholder="Selecionar campo"
              class="flex-shrink-0"
            />
            <SingleSelect
              v-if="isBooleanContactAttr"
              v-model="contactAttrValModelBoolean"
              :options="booleanOptions"
              :dropdown-max-height="dropdownMaxHeight"
              disable-deselect
              placeholder="Selecionar opção"
              class="flex-shrink-0"
            />
            <NextInput
              v-else
              v-model="contactAttrValModel"
              type="text"
              size="sm"
              placeholder="Valor do atributo"
            />
          </template>
          <template v-else-if="inputType === 'contact_custom_attribute'">
            <SingleSelect
              v-model="contactCustomAttrKeyModel"
              :options="contactCustomAttributesAsOptions"
              :dropdown-max-height="dropdownMaxHeight"
              disable-deselect
              placeholder="Selecionar atributo personalizado"
              class="flex-shrink-0"
            />
            <SingleSelect
              v-if="selectedContactCustomAttrType === 'list'"
              v-model="contactCustomAttrValModelSelect"
              :options="selectedContactCustomAttrListOptions"
              :dropdown-max-height="dropdownMaxHeight"
              disable-deselect
              placeholder="Selecionar opção"
              class="flex-shrink-0"
            />
            <SingleSelect
              v-else-if="selectedContactCustomAttrType === 'checkbox' || ['is_client', 'signed_contract'].includes(contactCustomAttrParam.attribute_key)"
              v-model="contactCustomAttrValModelBoolean"
              :options="booleanOptions"
              :dropdown-max-height="dropdownMaxHeight"
              disable-deselect
              placeholder="Selecionar opção"
              class="flex-shrink-0"
            />
            <NextInput
              v-else
              v-model="contactCustomAttrValModel"
              :type="selectedContactCustomAttrType === 'number' ? 'number' : 'text'"
              size="sm"
              placeholder="Valor do atributo"
            />
          </template>
          <template v-else-if="inputType === 'conversation_custom_attribute'">
            <SingleSelect
              v-model="convCustomAttrKeyModel"
              :options="convCustomAttributesAsOptions"
              :dropdown-max-height="dropdownMaxHeight"
              disable-deselect
              placeholder="Selecionar atributo da conversa (Kanban)"
              class="flex-shrink-0"
            />
            <SingleSelect
              v-if="selectedConvCustomAttrType === 'list'"
              v-model="convCustomAttrValModelSelect"
              :options="selectedConvCustomAttrListOptions"
              :dropdown-max-height="dropdownMaxHeight"
              disable-deselect
              placeholder="Selecionar etapa / opção"
              class="flex-shrink-0"
            />
            <SingleSelect
              v-else-if="selectedConvCustomAttrType === 'checkbox'"
              v-model="convCustomAttrValModelBoolean"
              :options="booleanOptions"
              :dropdown-max-height="dropdownMaxHeight"
              disable-deselect
              placeholder="Selecionar opção"
              class="flex-shrink-0"
            />
            <NextInput
              v-else
              v-model="convCustomAttrValModel"
              :type="selectedConvCustomAttrType === 'number' ? 'number' : 'text'"
              size="sm"
              placeholder="Valor do atributo"
            />
          </template>
        </template>
        <NextButton
          v-if="!isMacro"
          sm
          solid
          slate
          icon="i-lucide-trash"
          class="flex-shrink-0"
          @click="removeAction"
        />
      </div>
      <AutomationActionTeamMessageInput
        v-if="inputType === 'team_message'"
        v-model="action_params"
        :teams="dropdownValues"
        :dropdown-max-height="dropdownMaxHeight"
      />
      <WootMessageEditor
        v-if="inputType === 'textarea'"
        v-model="castMessageVmodel"
        rows="4"
        enable-variables
        :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
        class="[&_.ProseMirror-menubar]:hidden px-3 py-1 bg-n-alpha-1 rounded-lg outline outline-1 outline-n-weak dark:outline-n-strong"
      />
    </div>
    <span v-if="errorMessage" class="text-sm text-n-ruby-11">
      {{ errorMessage }}
    </span>
  </li>
</template>
